var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccount = function SvgAccount(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.373 15a2.25 2.25 0 0 0-2.123-1.5H6.75a2.25 2.25 0 0 0-2.25 2.25v.536C4.5 19.075 7.657 21 12 21c2.297 0 4.262-.568 5.603-1.5H12v-.75h6.476a4 4 0 0 0 .746-1.125H12v-.75h7.448a3.4 3.4 0 0 0 .052-.589v-.536H12V15zM16.5 7.5q0-.285-.034-.563H12v-.75h4.305a4.5 4.5 0 0 0-.522-1.125H12v-.75h3.176a4.5 4.5 0 1 0 0 6.376H12v-.75h3.783q.337-.521.523-1.126H12v-.75h4.466q.033-.276.034-.562"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/account.f4462ab968f615874a52b6011234556d.svg";